import { render, staticRenderFns } from "./profit-popover-panel.vue?vue&type=template&id=d5a28a46&scoped=true&"
import script from "./profit-popover-panel.vue?vue&type=script&lang=js&"
export * from "./profit-popover-panel.vue?vue&type=script&lang=js&"
import style0 from "./profit-popover-panel.vue?vue&type=style&index=0&id=d5a28a46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a28a46",
  null
  
)

export default component.exports